// src/pages/Order/OrderDashboard.jsx
import React from "react";
import "./orderDashboard.css";
import { Card, Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { ShoppingOutlined } from "@ant-design/icons";
import { accessChecker } from "../../lib/functions";

const { Title } = Typography;

const OrderDashboard = () => {
  const navigate = useNavigate();

  const links = [
    {
      key: "sales_order_entry",
      title: "Sales Order Entry",
      value: "sales_order_entry",
      path: "/order/sales?tab=entry",
    },
    {
      key: "sales_order_record",
      title: "Sales Order Record",
      value: "sales_order_record",
      path: "/order/sales?tab=record",
    },
    {
      key: "sales_order_voucher",
      title: "Sales Order Voucher",
      value: "sales_order_voucher",
      path: "/order/sales?tab=voucher",
    },
    {
      key: "purchase_order_entry",
      title: "Purchase Order Entry",
      value: "purchase_order_entry",
      path: "/order/purchase?tab=entry",
    },
    {
      key: "purchase_order_record",
      title: "Purchase Order Record",
      value: "purchase_order_record",
      path: "/order/purchase?tab=record",
    },
    {
      key: "purchase_order_voucher",
      title: "Purchase Order Voucher",
      value: "purchase_order_voucher",
      path: "/order/purchase?tab=voucher",
    },
  ];

  const filteredMenuData = links.filter((menuItem) =>
    accessChecker(menuItem.value)
  );

  return (
    <div className="dashboard-container">
      <Title level={3}>Order Dashboard</Title>
      <Row gutter={[16, 16]}>
        {filteredMenuData
          ?.sort((a, b) => a.title.localeCompare(b.title))
          .map((item, i) => (
            <Col xs={24} sm={12} md={8} lg={6} key={i}>
              <Card
                hoverable
                onClick={() => navigate(item.path)}
                className="dashboard-card"
              >
                <ShoppingOutlined style={{ fontSize: 28, marginBottom: 12 }} />
                <p>{item.title}</p>
              </Card>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default OrderDashboard;
